import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS,
  AFFILIATE_PROGRAM_COMMISSIONS_ROUTE_NAME,
} from '@modules/affiliate-program-commissions/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import { AFFILIATE_PROGRAM_COMMISSIONS_EDIT_ROUTE_NAME } from './constants';

export class AffiliateProgramCommissionsEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_PROGRAM_COMMISSIONS_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_COMMISSIONS_EDIT_ROUTE_NAME,
      path: 'settings/:id?',
      permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.EDIT,
      component: () => import('./pages/AffiliateProgramCommissionsEditPage/AffiliateProgramCommissionsEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
